import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import './libs'
import './permission'
import './styles/index.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
